import React from "react";
import { Box, Tooltip } from "@mui/material";
import colors from "../../../theme/colors";

/**
 * FieldHint — the small "?" beside a field label, revealing an explanation on
 * hover or focus.
 *
 * For the sentence a field needs only *sometimes*. Helper text under the control
 * is for the one-liner everyone should read ("Funded at closing"); this is for
 * the paragraph that would otherwise make every row three lines tall.
 *
 * It is focusable and carries a label, so the explanation is reachable by
 * keyboard and to a screen reader rather than being hover-only trivia.
 */
const FieldHint = ({ text, ariaLabel = "More information" }) => {
  if (!text) return null;
  return (
    <Tooltip title={text} placement="top" arrow enterTouchDelay={0}>
      <Box
        component="span"
        tabIndex={0}
        role="button"
        aria-label={ariaLabel}
        sx={{
          flex: "none",
          width: 16,
          height: 16,
          borderRadius: "50%",
          border: `1.4px solid ${colors.slate300}`,
          color: colors.slate400,
          fontSize: 10,
          fontWeight: 700,
          lineHeight: 1,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "default",
          transition: "border-color .15s, color .15s",
          "&:hover, &:focus-visible": {
            borderColor: "primary.main",
            color: "primary.main",
          },
        }}
      >
        ?
      </Box>
    </Tooltip>
  );
};

export default FieldHint;
